import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useResetUserOtpMutation } from "@/hooks/mutations/useResetUserOtp";
import { useToggleUserActivationMutation } from "@/hooks/mutations/useToggleUserActivation";
import { queryKeys } from "@/lib/query-keys";
import type { User } from "@/lib/users.api";

export function useUsersPageActions() {
  const queryClient = useQueryClient();
  const toggleMutation = useToggleUserActivationMutation();
  const resetOtpMutation = useResetUserOtpMutation();

  const busyId = toggleMutation.isPending
    ? toggleMutation.variables?.id
    : resetOtpMutation.isPending
      ? resetOtpMutation.variables
      : null;

  function reloadUsers() {
    queryClient.invalidateQueries({ queryKey: queryKeys.users() });
  }

  function toggleActivation(user: User) {
    toggleMutation.mutate({ id: user.id, active: !user.active });
  }

  function resetOtp(user: User) {
    resetOtpMutation.mutate(user.id, {
      onSuccess: (response) => {
        const delivery = response.data.otpDelivery;
        if (delivery.manualOtp) {
          toast.warning(`Code OTP manuel pour ${user.email}`, {
            description: `Email indisponible. Code: ${delivery.manualOtp}`,
            duration: 30000,
          });
          return;
        }

        toast.success(`Nouveau code OTP envoye a ${user.email}.`);
      },
    });
  }

  return {
    busyId,
    reloadUsers,
    resetOtp,
    toggleActivation,
  };
}
